var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: _vm.animation } }, [
    _vm.show
      ? _c(
          "div",
          { staticClass: "modal", attrs: { tabindex: "-1", role: "dialog" } },
          [
            _c(
              "div",
              {
                staticClass: "modal-dialog",
                class: _vm.alignmentClass,
                attrs: { role: "document" },
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-content", class: `${_vm.theme}-theme` },
                  [
                    _vm.closeButtonVisibility &&
                    _vm.closeButtonTarget === "content"
                      ? _c(
                          "button",
                          {
                            staticClass: "modal-close",
                            attrs: { type: "button" },
                            on: { click: _vm.onClickCloseBtn },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "33",
                                  height: "32",
                                  viewBox: "0 0 33 32",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "currentColor",
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M9.13318 8.43201C8.55717 9.00801 8.55717 9.94191 9.13318 10.5179L14.6153 16L9.13318 21.4821C8.55717 22.0581 8.55717 22.992 9.13318 23.568C9.70919 24.144 10.6431 24.144 11.2191 23.568L16.7012 18.0859L22.1833 23.568C22.7593 24.144 23.6932 24.144 24.2692 23.568C24.8452 22.992 24.8452 22.0581 24.2692 21.4821L18.7871 16L24.2692 10.5179C24.8452 9.94191 24.8452 9.00801 24.2692 8.43201C23.6932 7.856 22.7593 7.856 22.1833 8.43201L16.7012 13.9141L11.2191 8.43201C10.6431 7.856 9.70919 7.856 9.13318 8.43201Z",
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "modal-body",
                        class: { "has-close": _vm.closeButtonVisibility },
                      },
                      [_vm._t("body")],
                      2
                    ),
                  ]
                ),
              ]
            ),
            _vm.closeButtonVisibility && _vm.closeButtonTarget === "backdrop"
              ? _c(
                  "button",
                  {
                    staticClass: "modal-close",
                    attrs: { type: "button" },
                    on: { click: _vm.onClickCloseBtn },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "32",
                          height: "32",
                          viewBox: "0 0 33 32",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            fill: "#fff",
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M9.13318 8.43201C8.55717 9.00801 8.55717 9.94191 9.13318 10.5179L14.6153 16L9.13318 21.4821C8.55717 22.0581 8.55717 22.992 9.13318 23.568C9.70919 24.144 10.6431 24.144 11.2191 23.568L16.7012 18.0859L22.1833 23.568C22.7593 24.144 23.6932 24.144 24.2692 23.568C24.8452 22.992 24.8452 22.0581 24.2692 21.4821L18.7871 16L24.2692 10.5179C24.8452 9.94191 24.8452 9.00801 24.2692 8.43201C23.6932 7.856 22.7593 7.856 22.1833 8.43201L16.7012 13.9141L11.2191 8.43201C10.6431 7.856 9.70919 7.856 9.13318 8.43201Z",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _c("div", {
              staticClass: "modal-backdrop",
              class: { "modal-backdrop_blurred": _vm.isBackdropBlurred },
              on: {
                click: function ($event) {
                  return _vm.$emit("click:backdrop")
                },
              },
            }),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }